module.exports = __webpack_public_path__ + "img/marker-a.61b73097.png";